import { useTranslation } from "react-i18next";

import { PERSONA_OPPORTUNITY_SET_GRID_CLASS } from "../../../lib/persona-opportunity-grid-classes.js";
import type { PersonaOpportunitySet } from "../../../types/persona-opportunities.types.js";
import { PersonaOpportunitySetCard } from "../PersonaOpportunitySetCard/PersonaOpportunitySetCard.js";

export interface PersonaOpportunitySetListProps {
  sets: PersonaOpportunitySet[];
  onSelectSet: (set: PersonaOpportunitySet) => void;
  onStopSet?: (set: PersonaOpportunitySet) => void;
  onDeleteSet?: (set: PersonaOpportunitySet) => void;
  onRetrySet?: (set: PersonaOpportunitySet) => void;
  onRegenerateSet?: (set: PersonaOpportunitySet) => void;
  canMutate?: boolean;
}

export function PersonaOpportunitySetList({
  sets,
  onSelectSet,
  onStopSet,
  onDeleteSet,
  onRetrySet,
  onRegenerateSet,
  canMutate = false,
}: PersonaOpportunitySetListProps) {
  const { t } = useTranslation();

  return (
    <section className="flex min-w-0 flex-col gap-3.5 overflow-x-visible">
      <h2 className="text-[15px] font-semibold leading-tight tracking-tight text-foreground">
        {t("personaOpportunities.yourSets")}
      </h2>
      <div className={PERSONA_OPPORTUNITY_SET_GRID_CLASS}>
        {sets.map((set) => (
          <PersonaOpportunitySetCard
            key={set.id}
            set={set}
            onClick={() => onSelectSet(set)}
            canMutate={canMutate}
            onStop={
              onStopSet && set.status === "GENERATING" ? () => onStopSet(set) : undefined
            }
            onDelete={
              onDeleteSet && (set.status === "READY" || set.status === "FAILED")
                ? () => onDeleteSet(set)
                : undefined
            }
            onRetry={
              onRetrySet && set.status === "FAILED" ? () => onRetrySet(set) : undefined
            }
            onRegenerate={
              onRegenerateSet && set.status === "READY"
                ? () => onRegenerateSet(set)
                : undefined
            }
          />
        ))}
      </div>
    </section>
  );
}
